import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiSkeleton = {
	styleOverrides: {
		root: {
			borderRadius: 12,
		},
	},
} satisfies Components<Theme>["MuiSkeleton"];
